export enum TabsChildren {
    USERS = "USERS",
    PERMISSIONS = "PERMISSIONS",
}